import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { CollectionLight } from '../collection-light.model';

@JsonObject('CollectionsLightResultsResponse')
export class CollectionsLightResultsResponse extends ApiResultsResponse<CollectionLight> {

  @JsonProperty('results', [CollectionLight])
  override results: CollectionLight[] = [];
}
